import React, { useState, useEffect, useCallback } from "react";
import { BottomScrollListener, useBottomScrollListener } from "react-bottom-scroll-listener";
import { debounce } from "lodash";
import ErrorModal from "./ErrorModal";
import {
  titleize,
  LOW_DEBOUNCE_TIME,
  SHOP_SPECIFIC_OFFER_KEY_FOR_SESSION_STORAGE,
  parseItemCondition,
  handleBackPage,
  handleStopScroll,
  parseGradeOverall,
  IPAD_WIDTH,
  enterDownHandler,
  scrollToTopPage,
  displayTranslations,
  getArtwork,
  CURRENCY_EURO,
  parseCategoryName,
  parseAmount,
  parseLanguage,
  pluralize,
  parseBigInteger, DEFAULT_PER_PAGE_PARAM, compareStrings
} from "../../utils/utils";
import ShowLargeImageModal from "./ShowLargeImageModal";
import ShowBlueprintImageFrontImage from "./ShowBlueprintImageFrontImage";
import I18n from 'i18n.js.erb'
import Accordion from "react-bootstrap/Accordion";
import Card from "react-bootstrap/Card";
import { addCartItemsQuantity } from "../../reducers/cart_icon_reducer";
import { useDispatch } from "react-redux";

import RequiredLoginAlertPopup from "./RequiredLoginAlertPopup";
import BlueprintImageFlowMarketModal from "./BlueprintImageFlowMarketModal";
import GameNameParser from "./GameNameParser";
import SuccessModal from "./SuccessModal";
import SendEmailModal from "./SendEmailModal";
import ExpansionIcon from "./ExpansionIcon";
import EncasingParser from "./EncasingParser";
import LanguageFlag from "./LanguageFlag";
import SuccessFlashMessage from "./SuccessFlashMessage";
import GradingCertificate from "./GradingCertificate";

const OffersForSingleBlueprintImage = ({
  logged_in_user,
  initialOffers,
  blueprintImage,
  owners,
  label_languages,
  sorting_options,
  sorting_directions,
  marketFlow,
  isBusinessAccount,
  currentUserEmail,
  currentUsername
}) => {

  const originalOffers = JSON.parse(initialOffers);
  const blueprint_image = JSON.parse(blueprintImage);
  const dispatch = useDispatch();
  const [initCompleted, setInitCompleted] = useState(false)
  const [offers, setOffers] = useState([]);
  const [allProductsIds, setAllProductsIds] = useState([])
  const [allProductsCount, setAllProductsCount] = useState(0)
  const initialFilters = {
    owner: null, label_language: null, encasing: null, condition: null, grade_overall: null,
    has_errors: null, max_price: null, sort_by: 'price', sorting_direction: 'asc'
  }
  const [filters, setFilters] = useState(initialFilters)
  const [page, setPage] = useState(1);
  const [hasLoadedAllOffers, setHasLoadedAllOffers] = useState(false);
  const [loading, setLoading] = useState(false);
  const [showSuccessFlashMessage, setShowSuccessFlashMessage] = useState(false)
  const [successFlashMessage, setSuccessFlashMessage] = useState('')
  const [showErrorModal, setShowErrorModal] = useState(false)
  const [showSuccessModal, setShowSuccessModal] = useState(false)
  const [successMessage, setSuccessMessage] = useState('')
  const [showZoomImg, setShowZoomImg] = useState(false)
  const [showMarketFlow, setShowMarketFlow] = useState(false)
  const [filterPannelIsOpen, setFilterPannelIsOpen] = useState(window.innerWidth >= 991);
  const [loadDataFromSessionStorage, setLoadDataFromSessionStorage] = useState(false);
  const [showRequiredLoginModal, setShowRequiredLoginModal] = useState(false);
  const [serialNumberToAskToSellerByEmail, setSerialNumberToAskToSellerByEmail] = useState(null)
  const [emailFrom, setEmailFrom] = useState({ username: currentUsername, email: currentUserEmail, text: '' })
  const [productToShowGradingCertificate, setProductToShowGradingCertificate] = useState(null)
  const [blueprintImage2ShowLargeImage, setBlueprintImage2ShowLargeImage] = useState(null);
  const [showCertificate, setShowCertificate] = useState(false);


  // console.log("all_products_ids: ", allProductsIds);

  useEffect(() => {
    if (initCompleted && offers.length === 0) {
      getOffers()
    }
  }, [offers]);


  useEffect(() => {
    if (!initCompleted) {
      setInitCompleted(true)

      let shopPrevData = sessionStorage.getItem(SHOP_SPECIFIC_OFFER_KEY_FOR_SESSION_STORAGE);
      if (shopPrevData) {
        shopPrevData = JSON.parse(shopPrevData);
      }
      let shopCurrentUrl = `/products/${blueprint_image.id}`;
      let functions = {
        setLoadDataFromSessionStorage: setLoadDataFromSessionStorage,
        setOffers: setOffers,
        setAllProductsIds: setAllProductsIds,
        setAllProductsCount: setAllProductsCount,
        setPage: setPage,
        setHasLoadedAllOffers: setHasLoadedAllOffers,
        setFilters: setFilters,
        setFilterPannelIsOpen: setFilterPannelIsOpen
      };
      if (shopPrevData && shopPrevData.url === shopCurrentUrl) {
        setOffers([])
        setPage(1)
        handleBackPage(SHOP_SPECIFIC_OFFER_KEY_FOR_SESSION_STORAGE, shopPrevData, functions);
      } else {
        setAllProductsIds(originalOffers.on_sale_products_ids)
        setAllProductsCount(originalOffers.all_products_count)
        appendOffers(originalOffers.on_sale_products)
      }

      enterDownHandler(setFilterPannelIsOpen)
    }
  }, []);

  useEffect(() => {
    if (initCompleted) {
      debouncedUpdateFilterPrice();
      return debouncedUpdateFilterPrice.cancel;
    }
  }, [filters.max_price, debouncedUpdateFilterPrice]);


  // Hook che permette il caricamento di nuovi prodotti in vendita da renderizzare sull'interfaccia
  // grafica non appena l'utente scrolla fino in fondo alla pagina (INFINITE SCROLL)
  const scrollRef = useBottomScrollListener(() => getOffers());


  // Funzione che permette di ottenere dal server nuovi prodotti in vendita da renderizzare sull'interfaccia grafica
  const getOffers = () => {
    if (!hasLoadedAllOffers) {
      let url = `/products/${blueprint_image.id}.json?page=${page}&per_page=${DEFAULT_PER_PAGE_PARAM}`
      Object.entries(filters).forEach(([fieldName, fieldValue]) => {
        if (fieldValue !== null)
          url += `&${fieldName}=${fieldValue}`
      })

      fetch(url, {
        method: 'GET'
      })
        .then(response => response.json())
        .then((data) => {
          setAllProductsIds(data.on_sale_products_ids)
          setAllProductsCount(data.all_products_count)
          setLoading(false)
          appendOffers(data.on_sale_products)
        })
        .catch((error) => {
          console.error("ERROR:", error);
          setShowErrorModal(true);
        });
    }
  }


  // Funzione che permette di concatenare i nuovi prodotti in vendita ottenuti del server all'array che contiene tutti i
  // prodotti da mostrare sull'interfaccia grafica all'utente
  const appendOffers = (newOffers) => {
    setOffers(offers.concat(newOffers));
    setPage(page + 1)
    if (newOffers.length < DEFAULT_PER_PAGE_PARAM)
      setHasLoadedAllOffers(true)
  }


  // Funzione che permette di ottenere dal server le carte in vednita che matchano con i filtri
  // di ricerca da lui specificati sull'interfaccia grafica
  const getOffersByMatchingFilters = (filter, value) => {
    const newFilters = { ...filters }
    newFilters[filter] = value;
    updateFilters(newFilters)
  }


  //Funzione che esegue l'update debouncato del filtro di ricerca delle carte per nome
  const debouncedUpdateFilterPrice = useCallback(
    debounce(() => updateFilters(filters), LOW_DEBOUNCE_TIME),
    [filters.max_price]
  );

  //Funzione che setta il nuovo filtro di ricerca delle carte per nome
  function onChangeFilterPriceHandler(newFilterPrice) {
    const newFilters = { ...filters }
    newFilters['max_price'] = newFilterPrice;
    setFilters(newFilters)
  }


  // Funzione che aggiorna i filtri di ricerca delle carte specificate dall'utente sull'interfaccia grafica e rilancia
  // la ricerca sulla carte in vendita che matchano con i nuovi filtri specificati
  const updateFilters = (newFilters) => {
    setFilters(newFilters)
    setLoading(true)
    setPage(1)
    setHasLoadedAllOffers(false)
    setOffers([]);
    scrollToTopPage()
  }


  // Funzione che permette di aggiungere un prodotto (o tutti i prodotti renderizzati sull'interfaccia grafica)
  // al carrello degli acquisti dell'utente
  const addCardToCartHandler = (offerId) => {
    if (logged_in_user) {
      const url = "/carts";

      if (offerId) {
        fetch(url, {
          method: "POST",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ items_ids: [offerId] }),
        })
          .then((response) => {
            if (!response.ok)
              throw Error("An error occour during saving data on the database");
            else
              return response.json()
          })
          .then((data) => {
            let newOffers = offers.map((offer) => {
              if (offer.id === offerId) {
                let newOffer = { ...offer }
                newOffer['already_in_cart'] = data.id;
                return newOffer
              }
              return offer;
            })
            setOffers(newOffers)
            dispatch(addCartItemsQuantity(data.cart_items_count))
            setShowSuccessFlashMessage(true)
            setSuccessFlashMessage(I18n.t('js.shopPage.productAddedToCart'))
          })
          .catch((error) => {
            console.error("ERROR:", error);
            setShowErrorModal(true);
          });

      } else if (allProductsIds.length > 0) {
        fetch(url, {
          method: "POST",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ items_ids: allProductsIds }),
        })
          .then((response) => {
            if (!response.ok)
              throw Error("An error occour during saving data on the database");
            else
              return response.json()
          })
          .then((data) => {
            let newOffers = offers.map((offer) => {
              let newOffer = { ...offer }
              if (offer.enable_purchase)
                newOffer['already_in_cart'] = data.id;
              return newOffer
            })
            setOffers(newOffers)
            dispatch(addCartItemsQuantity(data.cart_items_count))
            setShowSuccessFlashMessage(true)
            setSuccessFlashMessage(I18n.t('js.shopPage.productAddedToCart'))
          })
          .catch((error) => {
            console.error("ERROR:", error);
            setShowErrorModal(true);
          });
      }
    } else {
      setShowRequiredLoginModal(true)
    }
  }


  // Funzione che permette di mostrare in full-screen l'immagine ingrandita di una carta
  const handleShowLargeImage = (e, product, blueprintImage) => {
    if (blueprintImage) {
      setBlueprintImage2ShowLargeImage(blueprintImage)
      setShowZoomImg(true)
    }
  }


  // Funzione che permette di mostrare in full-screen la modale con l'andamento di mercato della carta
  const handleShowMarketFlow = () => {
    if (marketFlow && marketFlow.length > 0) {
      setShowMarketFlow(true)
    }
  }


  // Funzione che gestisce la navigazione alla pagina che contiene tutte le carte
  // dell'espansione cliccata sull'interfaccia grafica dell'utente
  const handleNavigation = (product) => {
    const shopPrevData = {
      url: `/products/${product.id}`,
      scrollY: window.scrollY
    };
    sessionStorage.setItem(SHOP_SPECIFIC_OFFER_KEY_FOR_SESSION_STORAGE, JSON.stringify(shopPrevData));
  };

  handleStopScroll(() => handleNavigation(blueprint_image))


  // Funzione che permette all'utente corrente di mettersi in contatto con il venditore di un certo prodotto esposto
  // sul marketplace inviandogli una mail
  const handleSendEmailToSeller = () => {
    if (emailFrom && emailFrom.email && emailFrom.text && serialNumberToAskToSellerByEmail) {
      const url = "/products/contact_seller";

      const body = {
        user_from: emailFrom.username,
        email_from: emailFrom.email,
        serial_number: serialNumberToAskToSellerByEmail,
        text: emailFrom.text
      }

      fetch(url, {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
        body: JSON.stringify(body),
      })
        .then((response) => {
          if (!response.ok)
            throw Error("An error occour during saving data on the database");
          else
            return response.json()
        })
        .then((data) => {
          setShowSuccessModal(true)
          setSuccessMessage({ message: I18n.t('js.shopPage.successSendingEmailMessage') })
        })
        .catch((error) => {
          console.error("ERROR:", error);
          setShowErrorModal(true);
        });
    }
  }



  const blueprintImageNames = displayTranslations(blueprint_image.en_name, blueprint_image.meta_name, blueprint_image.language)
  const eraNames = displayTranslations(blueprint_image.en_era_name, blueprint_image.era_name, blueprint_image.language)
  const expansionNames = displayTranslations(blueprint_image.en_expansion_name, blueprint_image.expansion_name, blueprint_image.language)

  return <div className="w-90 m-auto mt-10px" >
    {/*filtri*/}
    <div>
      {
        !filterPannelIsOpen ?
          <React.Fragment>
            <div
              className={`${JSON.stringify(filters) !== JSON.stringify(initialFilters) && 'icon--bg-active'} rounded-right show-on-desktop expansion__filter--mobile-position top-170px`}>
              <button type="button" className="btn p-7px"
                id="open_filter_panel"
                onClick={(e) => setFilterPannelIsOpen(true)}>
                <i
                  className={`${JSON.stringify(filters) !== JSON.stringify(initialFilters) ? 'icon--color-active' : 'icon-color-standard'} fas fa-filter enable-filters-expansions-icon`} />
              </button>
            </div>

            {/*mobile button*/}
            <div
              className={`${JSON.stringify(filters) !== JSON.stringify(initialFilters) && 'icon--bg-active'} rounded-right show-on-mobile expansion__filter--mobile-position`}>
              <button type="button" className="btn p-7px"
                onClick={(e) => setFilterPannelIsOpen(true)}>
                <i
                  className={`${JSON.stringify(filters) !== JSON.stringify(initialFilters) ? 'icon--color-active' : 'icon-color-standard'} fas fa-filter enable-filters-expansions-icon`} />
              </button>
            </div>
          </React.Fragment>
          :
          <React.Fragment>
            {
              filterPannelIsOpen &&
              <div className="pl-4 pr-4 pb-4 filters-top-bar bg-light overflow-auto shadow"
                id="filters">
                <div className="row">
                  <div className="col-12 text-right p-lg-0">
                    <button type="button" className="btn p-0 mt-8px mr-4px"
                      id="close_filter_panel"
                      onClick={(e) => setFilterPannelIsOpen(false)}>
                      <i className="fas fa-times show-on-mobile" />
                      <i className="fas fa-chevron-times show-on-desktop-imp" />
                    </button>
                  </div>
                </div>

                <div className="row mb-2">
                  <div className="col-12">
                    <h4 className="mt-0 mb-0">{I18n.t('js.filters.by')}</h4>
                  </div>
                </div>

                <div className="row">
                  <div className="col-lg-2 col-md-3 col-6 mb-2">
                    <p className="mb-0">{I18n.t('js.filters.sort.owner')}</p>
                    <select
                      className={`form-control ${filters.owner ? 'border-aiG-blue-imp' : ''} p-0`}
                      value={filters.owner ? filters.owner : ""}
                      name="owner_filter"
                      id="owner_filter"
                      onChange={(e) => getOffersByMatchingFilters('owner', e.target.value)}
                    >
                      <option value={""}>{I18n.t('js.filters.sort.owner')}</option>
                      {owners.map((owner) => (
                        <option value={owner[1]} key={owner[1]}>
                          {owner[0]}
                        </option>
                      ))}
                    </select>
                  </div>

                  {/*<div className="col-lg-2 col-md-3 col-6 mb-2">*/}
                  {/*  <p className="mb-0">{I18n.t('js.filters.sort.errors')}</p>*/}
                  {/*  <select*/}
                  {/*    className="form-control p-0"*/}
                  {/*    value={filters.has_errors ? filters.has_errors : ""}*/}
                  {/*    name="errors_filter"*/}
                  {/*    id="errors_filter"*/}
                  {/*    onChange={(e) => getOffersByMatchingFilters('has_errors', e.target.value)}*/}
                  {/*  >*/}
                  {/*    <option value={""}>{I18n.t('js.filters.sort.errors')}</option>*/}
                  {/*    {[['js.common.choice_yes', 'true'], ['js.common.choice_no', 'false']].map((has_errors) => (*/}
                  {/*      <option value={has_errors[1]} key={has_errors[1]}>*/}
                  {/*        {I18n.t(has_errors[0])}*/}
                  {/*      </option>*/}
                  {/*    ))}*/}
                  {/*  </select>*/}
                  {/*</div>*/}

                  <div className="col-lg-2 col-md-3 col-6 mb-2">
                    <p className="mb-0">{I18n.t('js.filters.sort.maxPrice')}</p>
                    <input
                      type="number"
                      min="0"
                      value={filters.max_price ? filters.max_price : ""}
                      className={`form-control ${filters.max_price ? 'border-aiG-blue-imp' : ''} p-1`}
                      placeholder={I18n.t('js.filters.defaultCardMinPrice')}
                      onChange={(e) => onChangeFilterPriceHandler(e.target.value)}
                      name="max_price_filter"
                      id="max_price_filter"
                    />
                  </div>

                  <div className="col-lg-2 col-md-3 col-6 mb-2">
                    <p className="mb-0">{I18n.t('js.filters.sort.minGrading')}</p>
                    <select
                      className={`form-control ${filters.grade_overall ? 'border-aiG-blue-imp' : ''} p-0`}
                      value={filters.grade_overall ? filters.grade_overall : ""}
                      name="grade_overall_filter"
                      id="grade_overall_filter"
                      onChange={(e) => getOffersByMatchingFilters('grade_overall', e.target.value)}
                    >
                      <option value={""}>{I18n.t('js.filters.defaultCardMinGrading')}</option>
                      {[1, 2, 3, 4, 5, 6, 7, 8, 9, 10].map((grade_overall) => (
                        <option value={grade_overall} key={grade_overall}>
                          {grade_overall}
                        </option>
                      ))}
                    </select>
                  </div>

                  <div className="col-lg-2 col-md-3 col-6 mb-2">
                    <p className="mb-0">{I18n.t('js.filters.sort.encasing')}</p>
                    <select
                      className={`form-control ${filters.encasing ? 'border-aiG-blue-imp' : ''} p-0`}
                      value={filters.encasing ? filters.encasing : ""}
                      name="encasing_filter"
                      id="encasing_filter"
                      onChange={(e) => getOffersByMatchingFilters('encasing', e.target.value)}
                    >
                      <option value={""}>{I18n.t('js.filters.defaultEncasing')}</option>
                      {[[I18n.t('js.common.submissionListType.sleeve') + ' / ' + I18n.t('js.common.submissionListType.sleeveExplanation'), 'sleeve'],
                      [I18n.t('js.common.submissionListType.case') + ' ' + I18n.t('js.common.submissionListType.caseExplanation'), 'case']].map((encasing) => (
                        <option value={encasing[1]} key={encasing[1]}>
                          {encasing[0]}
                        </option>
                      ))}
                    </select>
                  </div>


                  <div className="col-lg-2 col-md-3 col-6 mb-2">
                    <p className="mb-0">{I18n.t('js.filters.sort.labelLanguage')}</p>
                    <select
                      className={`form-control ${filters.label_language ? 'border-aiG-blue-imp' : ''} p-0`}
                      value={filters.label_language ? filters.label_language : ""}
                      name="label_language_filter"
                      id="label_language_filter"
                      onChange={(e) => getOffersByMatchingFilters('label_language', e.target.value)}
                    >
                      <option value={""}>{I18n.t('js.filters.defaultLabelLanguage')}</option>
                      {label_languages.map((label_language) => (
                        <option value={label_language} key={label_language}>
                          {label_language.toUpperCase()}
                        </option>
                      ))}
                    </select>
                  </div>

                  {
                    isBusinessAccount &&
                    <div className="col-lg-2 col-md-3 col-6 mb-2">
                      <p className="mb-0">{I18n.t('js.filters.sort.condition')}</p>
                      <select
                        className={`form-control ${filters.condition ? 'border-aiG-blue-imp' : ''} p-0`}
                        value={filters.condition ? filters.condition : ""}
                        name="condition_filter"
                        id="condition_filter"
                        onChange={(e) => getOffersByMatchingFilters('condition', e.target.value)}
                      >
                        <option value={""}>{I18n.t('js.filters.defaultCardCondition')}</option>
                        {[[I18n.t('js.myCollectionEditPage.condition.new'), 'new'],
                        [I18n.t('js.myCollectionEditPage.condition.used'), 'used']].map((condition) => (
                          <option value={condition[1]} key={condition[1]}>
                            {condition[0]}
                          </option>
                        ))}
                      </select>
                    </div>
                  }

                  <div className="col-lg-2 col-md-3 col-6 mb-2 mt-17px">
                    <button
                      className="btn-standard-outline br-20px mt-1 pt-1 pb-1 btn-standard-outline-resized w-100"
                      onClick={() => {
                        updateFilters(initialFilters);
                        if (window.innerWidth <= IPAD_WIDTH)
                          setFilterPannelIsOpen(false)
                      }}>
                      {I18n.t('js.filters.resetFilter')}
                    </button>
                  </div>

                  <div className="col-lg-2 col-md-3 col-6 mb-2 mt-17px show-on-mobile">
                    <button
                      className="btn-standard bg-aig-gradient text-light br-20px mt-1 pt-1 pb-1 pr-5 pl-5 btn-standard-outline-resized w-100"
                      onClick={(e) => setFilterPannelIsOpen(false)}>
                      {I18n.t('js.advancedSearch.filterComponent.search')}
                    </button>
                  </div>
                </div>

                <div className="row mt-2">
                  <div className="col-xs-12 col-lg-4 d-block">
                    <h4 className="mt-0 mb-0">{I18n.t('js.indexOrdersPage.sortBy')}</h4>
                    <div className="d-flex justify-content-start align-items-center">
                      <select
                        className={`form-control ${filters.sort_by ? 'border-aiG-blue-imp' : ''} mr-1`}
                        name="sort_by" id="sort_by" value={filters.sort_by}
                        style={{ minWidth: "55%" }}
                        onChange={(e) => getOffersByMatchingFilters('sort_by', e.target.value)}>
                        {sorting_options.map(option => {
                          return <option value={option.value} key={option.value}>{I18n.t(option.locale)}</option>
                        })}
                      </select>
                      <span>
                        <b>:</b>
                      </span>
                      <select
                        className={`form-control ${filters.sorting_direction ? 'border-aiG-blue-imp' : ''} ml-1`}
                        name="sorting_direction" id="sorting_direction"
                        value={filters.sorting_direction}
                        onChange={(e) => getOffersByMatchingFilters('sorting_direction', e.target.value)}>
                        {sorting_directions.map(direction => {
                          return <option value={direction.value}
                            key={direction.value}>{I18n.t(direction.locale)}</option>
                        })}
                      </select>
                    </div>
                  </div>
                </div>
              </div>
            }
          </React.Fragment>
      }
    </div>

    <div
      className={`${filterPannelIsOpen ? 'mt-shop-compare-offers-with-open-filter' : 'mt-5'}  title-core-pages row mb-3`}>
      <div className={`col-12 col-lg-6 p-0 d-flex ${window.innerWidth > IPAD_WIDTH && 'mt-5'}`}>
        <h2>
          {I18n.t('js.shopPage.offersOf')}&nbsp;

          {
            blueprintImageNames.length > 1 ?
              <React.Fragment>
                {I18n.t('js.shopPage.offersOf')}&nbsp;
                {blueprintImageNames[0]}&nbsp;
                <span>
                  ({blueprintImageNames[1]})
                </span>
              </React.Fragment>
              :
              <React.Fragment>
                {blueprintImageNames[0]}
              </React.Fragment>
          }

          {
            blueprint_image.expansion.icon_url &&
            <span key={blueprint_image.expansion.icon_url} className="ml-2 mt-3">
              <ExpansionIcon
                icon_url={blueprint_image.expansion.icon_url}
                width={"40px"}
              />
            </span>
          }
        </h2>
      </div>
    </div>

    <div className="row bg-white row-with-scroll mt-30px d-none d-md-flex align-items-center">
      <div className="col-md-3 col-lg-2 mt-10px mb-10px pl-0">
        <ShowBlueprintImageFrontImage
          size={'medium'}
          blueprintImage={blueprint_image}
          handleShowLargeImage={(e) => handleShowLargeImage(e, null, blueprint_image)}
          textOverlayPlaceholder={getArtwork(blueprint_image)}
        />
      </div>

      <div className="col-md-4 col-lg-3 mt-10px">
        <div className="d-flex justify-content-start mb-2">
          <span className="text-weight-600">{I18n.t('js.myCollectionEditPage.tableHeaderGame')}:&nbsp;</span>
          <GameNameParser
            game_name={blueprint_image.game.name}
            additionalClasses1={"mb-0"}
          />
        </div>
        <p>
          <span className="text-weight-600">
            {I18n.t('js.myCollectionEditPage.tableHeaderCategory')}:
            &nbsp;
          </span>
          {parseCategoryName(blueprint_image.blueprint.category.name)}
        </p>
        <p>
          <span className="text-weight-600">{I18n.t('js.myCollectionEditPage.tableHeaderName')}:&nbsp;</span>
          {
            blueprintImageNames.length > 1 ?
              <React.Fragment>
                <span className="mb-0">
                  {blueprintImageNames[0]}
                </span>&nbsp;
                <span className="text--size-small">
                  ({blueprintImageNames[1]})
                </span>
              </React.Fragment>
              :
              <span id={"name_" + blueprint_image.id}>
                {blueprintImageNames[0]}
              </span>
          }
        </p>
        <p>
          <span className="text-weight-600">{I18n.t('js.shopPage.cn')}&nbsp;</span>
          {
            blueprint_image.collector_number && blueprint_image.collector_number !== '' ?
              <span>{blueprint_image.collector_number}</span>
              :
              <span>{I18n.t('js.common.noData')}</span>
          }
        </p>
        <p>
          <span className="text-weight-600">{I18n.t('js.myCollectionEditPage.tableHeaderEra')}:&nbsp;</span>
          {
            eraNames.length > 1 ?
              <React.Fragment>
                <span className="mb-0">
                  {eraNames[0]}
                </span>&nbsp;
                <span className="text--size-small">
                  ({eraNames[1]})
                </span>
              </React.Fragment>
              :
              <span className="mb-0">
                {eraNames[0]}
              </span>
          }
        </p>
        <p>
          <span className="text-weight-600">{I18n.t('js.myCollectionEditPage.tableHeaderExpansion')}:&nbsp;</span>
          {
            expansionNames.length > 1 ?
              <React.Fragment>
                <span className="mb-0">
                  {expansionNames[0]}&nbsp;
                </span>
                <span className="text--size-small">
                  ({expansionNames[1]})
                </span>
              </React.Fragment>
              :
              <span>
                {expansionNames[0]}
              </span>
          }

          <ExpansionIcon
            icon_url={blueprint_image.expansion.icon_url}
            width={'25px'}
          />
        </p>
      </div>

      <div className="col-6 col-md-4 col-lg-3 mt-10px">
        <p><span className="text-weight-600">{I18n.t('js.cardInfoPage.language')}:&nbsp;</span>
          {
            blueprint_image.language_filter &&
            <span className="mb-0">{parseLanguage(blueprint_image.language_filter)}</span>
          }
        </p>

        <p><span className="text-weight-600">{I18n.t('js.filters.sort.version')}:&nbsp;</span>
          {
            blueprint_image.version ?
              <span className="mb-0">{titleize(blueprint_image.version)}</span>
              :
              <span>{I18n.t('js.common.noData')}</span>
          }
        </p>

        <p><span className="text-weight-600">{I18n.t('js.filters.sort.rarity')}:&nbsp;</span>
          {
            blueprint_image.rarity ?
              <span className="mb-0">{titleize(blueprint_image.rarity)}</span>
              :
              <span>{I18n.t('js.common.noData')}</span>
          }
          {blueprint_image.rarity_logo_url &&
            <img src={blueprint_image.rarity_logo_url} alt="" className="ml-1 mb-1"
              style={{ maxWidth: '15px' }} />
          }
        </p>

        <p><span className="text-weight-600">{I18n.t('js.filters.sort.edition')}:&nbsp;</span>
          {blueprint_image.edition && !compareStrings(blueprint_image.edition, 'Undefined') && blueprint_image.edition !== "" ?
            <span>{blueprint_image.edition}</span>
            :
            <span>{I18n.t('js.common.noData')}</span>
          }
        </p>

        <p><span className="text-weight-600">{I18n.t('js.filters.sort.releaseDate')}:&nbsp;</span>
          {
            blueprint_image.released_at && blueprint_image.released_at !== '' &&
            <span>{titleize(blueprint_image.released_at)}</span>
          }
        </p>

        {
          !loading && offers.length > 0 &&
          <button type="button"
            className="btn-standard bg-aig-gradient text-light br-20px shadow pr-4 pl-4 btn-standard-resized btn-buy-all-height"
            onClick={(e) => addCardToCartHandler(null)}>
            <i className="fas fa-shopping-cart mr-2" />
            {I18n.t('js.shopPage.addAllToCart')}
          </button>
        }

      </div>

      <div className="col-md-12 col-lg-4 mt-10px mb-2">
        {
          marketFlow && marketFlow.length > 0 &&
          <button type="button"
            className="btn btn-standard bg-dark text-light"
            onClick={handleShowMarketFlow}>
            <i className="fa fa-line-chart icon-in-btn-size mr-8px" />
            {I18n.t('js.marketChart.viewMarketFlow')}
          </button>
        }
      </div>

    </div>

    <div className="row bg-white mt-30px d-md-none pt-15px">
      <div className="col-10  p-0 text-center text-center m-auto">

        <ShowBlueprintImageFrontImage
          size={'medium'}
          blueprintImage={blueprint_image}
          handleShowLargeImage={(e) => handleShowLargeImage(e, null, blueprint_image)}
        />

        <div className="row mt-10px">
          <div className="col-12">
            {
              !loading && offers.length > 0 &&
              <button type="button"
                className="btn-standard bg-aig-gradient text-light br-20px shadow pr-4 pl-4 btn-standard-resized w-100"
                onClick={(e) => addCardToCartHandler(null)}>
                <i className="fas fa-shopping-cart mr-2" />
                {I18n.t('js.shopPage.addAllToCart')}
              </button>
            }
          </div>
        </div>

        <div className="row mt-10px">
          <div className="col-12">
            <Accordion className="w-100 mb-3 rounded" key="Info">
              <Card className="bg-white border-none border-round-standard">
                <Accordion.Toggle as={Card.Header} className="text-light bg-dark" eventKey="0">
                  <i className="fa fa-info-circle icon-in-btn-size" />&nbsp;
                  {I18n.t('js.shopPage.info')}
                </Accordion.Toggle>
                <Accordion.Collapse eventKey='0'>
                  <div className="row mt-10px pb-3">
                    <div className="col-12 text-left">
                      <p>
                        <span className="text-weight-600">{I18n.t('js.myCollectionEditPage.tableHeaderGame')}:&nbsp;</span>
                        {blueprint_image.game.name
                          .split(" ")
                          .map((substring, i) =>
                            i === 0 ?
                              <span className="mb-0" key={substring}>{substring}</span>
                              :
                              <span className="text--size-small" key={substring}>{substring}</span>
                          )}
                      </p>
                      <p>
                        <span className="text-weight-600">
                          {I18n.t('js.myCollectionEditPage.tableHeaderCategory')}:
                          &nbsp;
                        </span>
                        {parseCategoryName(blueprint_image.blueprint.category.name)}
                      </p>
                      <p>
                        <span className="text-weight-600">{I18n.t('js.myCollectionEditPage.tableHeaderName')}:&nbsp;</span>
                        {
                          blueprintImageNames.length > 1 ?
                            <React.Fragment>
                              <span className="mb-0">
                                {blueprintImageNames[0]}
                              </span>
                              <span className="text--size-small">
                                ({blueprintImageNames[1]})
                              </span>
                            </React.Fragment>
                            :
                            <span id={"name_" + blueprint_image.id}>
                              {blueprintImageNames[0]}
                            </span>
                        }
                      </p>
                      <p>
                        <span className="text-weight-600">{I18n.t('js.shopPage.cn')}&nbsp;</span>
                        {
                          blueprint_image.collector_number && blueprint_image.collector_number !== '' ?
                            <span>{blueprint_image.collector_number}</span>
                            :
                            <span>{I18n.t('js.common.noData')}</span>
                        }
                      </p>
                      <p>
                        <span className="text-weight-600">{I18n.t('js.myCollectionEditPage.tableHeaderEra')}:&nbsp;</span>
                        {
                          eraNames.length > 1 ?
                            <React.Fragment>
                              <span className="mb-0">
                                {eraNames[0]}&nbsp;
                              </span>
                              <span className="text--size-small">
                                ({eraNames[1]})
                              </span>
                            </React.Fragment>
                            :
                            <span className="mb-0">
                              {eraNames[0]}
                            </span>
                        }
                      </p>
                      <p>
                        <span className="text-weight-600">{I18n.t('js.myCollectionEditPage.tableHeaderExpansion')}:&nbsp;</span>
                        {
                          expansionNames.length > 1 ?
                            <React.Fragment>
                              <span className="mb-0">
                                {expansionNames[0]}&nbsp;
                              </span>
                              <span className="text--size-small">
                                ({expansionNames[1]})
                              </span>
                            </React.Fragment>
                            :
                            <span>
                              {expansionNames[0]}
                            </span>
                        }

                        <ExpansionIcon
                          icon_url={blueprint_image.expansion.icon_url}
                          width={'25px'}
                        />
                      </p>
                      <p><span className="text-weight-600">{I18n.t('js.cardInfoPage.language')}:&nbsp;</span>
                        {
                          blueprint_image.language_filter &&
                          <span className="mb-0">{titleize(blueprint_image.language_filter)}</span>
                        }
                      </p>
                      <p><span className="text-weight-600">{I18n.t('js.filters.sort.version')}:&nbsp;</span>
                        {
                          blueprint_image.version ?
                            <span className="mb-0">{titleize(blueprint_image.version)}</span>
                            :
                            <span>{I18n.t('js.common.noData')}</span>
                        }
                      </p>
                      <p><span className="text-weight-600">{I18n.t('js.filters.sort.rarity')}:&nbsp;</span>
                        {
                          blueprint_image.rarity ?
                            <span className="mb-0">{titleize(blueprint_image.rarity)}</span>
                            :
                            <span>{I18n.t('js.common.noData')}</span>
                        }
                        {blueprint_image.rarity_logo_url &&
                          <img src={blueprint_image.rarity_logo_url} alt="" className="ml-1 mb-1"
                            style={{ maxWidth: '15px' }} />
                        }
                      </p>
                      <p><span className="text-weight-600">{I18n.t('js.filters.sort.edition')}:&nbsp;</span>
                        {blueprint_image.edition && !compareStrings(blueprint_image.edition, 'Undefined') && blueprint_image.edition !== "" ?
                          <span>{blueprint_image.edition}</span>
                          :
                          <span>{I18n.t('js.common.noData')}</span>
                        }
                      </p>
                      <p><span className="text-weight-600">{I18n.t('js.filters.sort.releaseDate')}:&nbsp;</span>
                        {
                          blueprint_image.released_at && blueprint_image.released_at !== '' &&
                          <span>{titleize(blueprint_image.released_at)}</span>
                        }
                      </p>

                      {
                        marketFlow && marketFlow.length > 0 &&
                        <button type="button"
                          className="btn btn-standard bg-dark text-light text--size-09rem-imp"
                          onClick={handleShowMarketFlow}>
                          <i className="fa fa-line-chart icon-in-btn-size mr-8px" />
                          {I18n.t('js.marketChart.viewMarketFlow')}
                        </button>
                      }
                    </div>
                  </div>
                </Accordion.Collapse>
              </Card>
            </Accordion>
          </div>
        </div>
      </div>
    </div>


    {
      loading ?
        <div className="d-flex justify-content-center mt-5">
          <div className="d-flex align-items-center text-muted">
            <div className="spinner-border" role="status" />
            <b className="ml-2">{I18n.t('js.shopPage.loadingProducts')}</b>
          </div>
        </div>
        :
        offers.length > 0 ?
          <BottomScrollListener onBottom={getOffers}>
            <React.Fragment>
              <div className="row rounded mt-30px">
                <div className="row mt-3">
                  <div className="col-12 col-md-6">
                    <p>
                      {parseBigInteger(allProductsCount)}&nbsp;
                      {pluralize(allProductsCount, 'editSubmissionListPage.product')}
                    </p>
                  </div>
                </div>

                <div className="table-responsive d-none d-md-block">
                  <table id="cart-edit"
                    className="table table-hover mt-30px bg-white">
                    <thead className="thead-dark">
                      <tr>
                        <th scope="col" className="text-center">{I18n.t('js.filters.sort.owner')}</th>
                        <th scope="col" className="text-center">{I18n.t('js.myCollectionEditPage.tableHeaderLabel')}</th>
                        {
                          isBusinessAccount &&
                          <th scope="col"
                            className="text-center">{I18n.t('js.myCollectionEditPage.tableHeaderCondition')}</th>
                        }
                        <th scope="col"
                          className="text-center">{I18n.t('js.myCollectionEditPage.tableHeaderGrading')}</th>
                        {/*<th scope="col" className="text-center">{I18n.t('js.filters.sort.errors')}</th>*/}
                        <th scope="col" className="text-center">{I18n.t('js.showCertificateModal.certificate')}</th>
                        <th scope="col" className="text-center">{I18n.t('js.filters.sort.cardPrice')}</th>
                        <th scope="col" className="text-center d-none d-lg-table-cell" />
                      </tr>
                    </thead>
                    <tbody>
                      {offers.map((offer, i) =>
                        <tr key={offer.id} id={offer.id}
                          className={offer.current_grading && offer.current_grading.is_valid && offer.current_grading.serial_number ? 'cursor-pointer' : ''}
                          onClick={() => offer.current_grading && offer.current_grading.is_valid && offer.current_grading.serial_number ? window.location = `/grading_certificate/${offer.current_grading.serial_number}` : {}}>
                          <td className="text-center ml-td">
                            <div className="d-block justify-content-center">
                              <p className="mb-2">{offer.user.username}</p>
                              {
                                offer.enable_purchase &&
                                <small className="text-underline-imp text-aiBlue"
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    setSerialNumberToAskToSellerByEmail(offer.current_grading.serial_number)
                                  }}>
                                  {I18n.t('js.shopProductDetailModal.contactSeller')}
                                </small>
                              }
                            </div>
                          </td>

                          <td className="text-center ml-td">
                            <div className="d-block mb-0">
                              <LanguageFlag
                                language={offer.current_grading.label_language}
                                containerCssClassList={'d-flex justify-content-center'}
                              />

                              <EncasingParser
                                encasing={offer.current_grading.encasing}
                                categoryName={blueprint_image.blueprint.category.name}
                              />
                            </div>
                          </td>
                          {
                            isBusinessAccount &&
                            <td className="text-center ml-td">
                              <p className="mb-0">{parseItemCondition(offer.condition)}</p>
                            </td>
                          }
                          <td className="text-center ml-td">
                            <p className="text-weight-700 mt-0" style={{ color: 'green' }}>
                              {parseGradeOverall(offer.current_grading)}
                            </p>
                            <small>({offer.current_grading.serial_number})</small>
                          </td>

                          <td className="text-center ml-td">
                            {
                              offer.current_grading.is_valid &&
                              <button type="button"
                                id="aig-certificate"
                                className="pt-10px-imp btn btn-standard bg-dark text-light pb-1 pt-1 px-3 btn-standard-resized noselect minH-40px-imp"
                                onClick={(e) => {
                                  e.stopPropagation()
                                  setBlueprintImage2ShowLargeImage(blueprint_image)
                                  setProductToShowGradingCertificate(offer)
                                  setShowCertificate(true)
                                }}
                              >
                                <i className="fas fa-award" />
                              </button>
                            }
                          </td>

                          <td className="text-center ml-td">
                            <p className="text-weight-700 mb-0">{parseAmount(offer.price) + CURRENCY_EURO}</p>

                            <div className="d-none d-md-block d-lg-none">
                              {!offer.already_in_cart ?
                                (offer.enable_purchase &&
                                  <button type="button"
                                    className="btn-standard bg-aig-gradient text-light br-20px shadow btn-standard-resized text--size-09rem-imp text--white-space-no-wrap w-100 maxH-25px pt-3px-imp"
                                    onClick={(e) => {
                                      e.stopPropagation();
                                      addCardToCartHandler(offer.id);
                                    }}>
                                    <i className="fas fa-shopping-cart" /> &nbsp;
                                    {I18n.t('js.shopPage.addToCart')}
                                  </button>)
                                :
                                <p className="mb-0" onClick={(e) => e.stopPropagation()}>
                                  {I18n.t('js.shopPage.thisProductIsIn')}
                                  <a href={`/carts/${offer.already_in_cart}/edit`}
                                    className="ml-1 data-structure-link"
                                    style={{ color: "inherit", textDecoration: "underline" }}>
                                    {I18n.t('js.shopPage.yourCart')}
                                  </a>
                                </p>
                              }
                            </div>


                          </td>
                          <td className="text-center ml-td d-none d-lg-block">
                            {!offer.already_in_cart ?
                              (offer.enable_purchase &&
                                <button type="button"
                                  id={`add-to-cart-btn-offer-${offer.id}`}
                                  className="btn-standard bg-aig-gradient text-light br-20px shadow btn-standard-resized text--size-09rem-imp text--white-space-no-wrap w-100 maxH-25px pt-3px-imp"
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    addCardToCartHandler(offer.id)
                                  }}>
                                  <i className="fas fa-shopping-cart" /> &nbsp;
                                  {I18n.t('js.shopPage.addToCart')}
                                </button>)
                              :
                              <p className="mb-0"
                                onClick={(e) => e.stopPropagation()}>
                                {I18n.t('js.shopPage.thisProductIsIn')}
                                <a href={`/carts/${offer.already_in_cart}/edit`}
                                  className="ml-1 data-structure-link"
                                  style={{ color: "inherit", textDecoration: "underline" }}>
                                  {I18n.t('js.shopPage.yourCart')}
                                </a>
                              </p>
                            }
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>

                <div className="d-md-none w-100">
                  {offers.map((offer, i) =>
                    <Accordion defaultActiveKey={offers[0].id} className="w-100 mb-4 border-aiG-black-imp br-2px" key={offer.id}>
                      <Card className="border-none remove-border-radius bg-sub-expansion-bg">
                        <Accordion.Toggle as={Card.Header} eventKey={offer.id} className="bg-white">
                          <div className="row">
                            <div className="col-4 text-center">
                              <div className="d-block justify-content-center">
                                <p className="mb-1">{offer.user.username}</p>
                                {
                                  offer.enable_purchase &&
                                  <small className="text-underline-imp text-aiBlue"
                                    onClick={(e) => {
                                      e.stopPropagation();
                                      setSerialNumberToAskToSellerByEmail(offer.current_grading.serial_number)
                                    }}>
                                    {I18n.t('js.shopProductDetailModal.contactSeller')}
                                  </small>
                                }
                              </div>
                            </div>
                            <div className="col-4 text-center">
                              <p className="mb-0">{parseAmount(offer.price) + CURRENCY_EURO}</p>
                            </div>
                            <div className="col-4 text-center">
                              <p className="mb-0">
                                {I18n.t('js.myCollectionEditPage.tableHeaderGrading')}:&nbsp;
                                {offer.current_grading.grade_overall === null && <br />}
                                <span className="mb-2 text-weight-700" style={{ color: 'green' }}>
                                  {parseGradeOverall(offer.current_grading)}
                                </span><br />
                                <small>({offer.current_grading.serial_number})</small>
                              </p>
                            </div>
                          </div>
                        </Accordion.Toggle>
                        <Accordion.Collapse eventKey={offer.id}>
                          <React.Fragment>
                            <div className="row pl-3 pt-3 pr-3 pb-1">
                              <div className="col-6">
                                <p className="mb-0">{I18n.t('js.filters.sort.labelLanguage')}</p>
                              </div>
                              <div className="col-6">
                                <div className="mb-0 text-right">
                                  <LanguageFlag
                                    language={offer.current_grading.label_language}
                                    containerCssClassList={'d-flex justify-content-end'}
                                  />
                                </div>
                              </div>
                            </div>
                            <div className="row pl-3 pr-3 pt-1 pb-1">
                              <div className="col-6">
                                <p className="mb-0">{I18n.t('js.filters.sort.encasing')}</p>
                              </div>
                              <div className="col-6">
                                <p className="mb-0 text-right">
                                  <EncasingParser
                                    encasing={offer.current_grading.encasing}
                                    categoryName={blueprint_image.blueprint.category.name}
                                  />
                                </p>
                              </div>
                            </div>
                            {
                              isBusinessAccount &&
                              <div className="row pl-3 pr-3 pt-1 pb-1">
                                <div className="col-6">
                                  <p className="mb-0">{I18n.t('js.filters.sort.condition')}</p>
                                </div>
                                <div className="col-6">
                                  <p className="mb-0 text-right">{parseItemCondition(offer.condition)}</p>
                                </div>
                              </div>
                            }
                            <div className="row pl-3 pr-3 pt-1 pb-3">
                              {
                                offer.current_grading && offer.current_grading.is_valid && offer.current_grading.serial_number &&
                                <div className="col-6 text-center">
                                  <a href={`/grading_certificate/${offer.current_grading.serial_number}`}
                                    className="btn btn-standard bg-dark text-light shadow btn-standard-resized text--size-09rem-imp text--white-space-no-wrap w-100 maxH-25px pt-3px-imp pr-2 pl-2">
                                    <i className="fas fa-eye" /> &nbsp;
                                    {I18n.t('js.shopPage.viewMore')}
                                  </a>
                                </div>
                              }
                              <div className="col-6">
                                {!offer.already_in_cart ?
                                  (offer.enable_purchase &&
                                    <button type="button"
                                      className="btn-standard bg-aig-gradient text-light br-20px shadow btn-standard-resized text--size-09rem-imp text--white-space-no-wrap w-100 maxH-25px pt-3px-imp"
                                      onClick={(e) => {
                                        e.stopPropagation()
                                        addCardToCartHandler(offer.id)
                                      }}>
                                      <i className="fas fa-shopping-cart" /> &nbsp;
                                      {I18n.t('js.shopPage.addToCart')}
                                    </button>)
                                  :
                                  <p className="mb-0 text-center"
                                    onClick={(e) => e.stopPropagation()}>
                                    {I18n.t('js.shopPage.thisProductIsIn')}
                                    <a href={`/carts/${offer.already_in_cart}/edit`}
                                      className="ml-1 data-structure-link"
                                      style={{ color: "inherit", textDecoration: "underline" }}>
                                      {I18n.t('js.shopPage.yourCart')}
                                    </a>
                                  </p>
                                }
                              </div>
                            </div>
                          </React.Fragment>
                        </Accordion.Collapse>
                      </Card>
                    </Accordion>
                  )}
                </div>
              </div>

              {
                !hasLoadedAllOffers && offers.length > 0 &&
                <div className="d-flex justify-content-center mt-5">
                  <div className="d-flex align-items-center text-muted">
                    <div className="spinner-border" role="status" />
                    <b className="ml-2">{I18n.t('js.common.loading')}</b>
                  </div>
                </div>
              }
            </React.Fragment>
          </BottomScrollListener>
          :
          <div className="d-flex justify-content-center mt-5 pt-5">
            <div className="d-flex align-items-center text-muted">
              <b className="ml-2">{I18n.t('js.shopPage.noOffers')}</b>
            </div>
          </div>
    }

    <ErrorModal
      showErrorModal={showErrorModal}
      setShowErrorModal={setShowErrorModal}
    />

    <SuccessFlashMessage
      showSuccessFlashMessage={showSuccessFlashMessage}
      setShowSuccessFlashMessage={setShowSuccessFlashMessage}
      successMessage={successFlashMessage}
    />

    <SuccessModal
      showSuccessModal={showSuccessModal}
      setShowSuccessModal={setShowSuccessModal}
      successMessage={successMessage}
    />

    <SendEmailModal
      request={serialNumberToAskToSellerByEmail}
      setRequest={setSerialNumberToAskToSellerByEmail}
      emailFrom={emailFrom}
      setEmailFrom={setEmailFrom}
      handleSendEmail={handleSendEmailToSeller}
    />

    <ShowLargeImageModal
      blueprintImage={blueprint_image}
      showZoomImg={showZoomImg}
      setShowZoomImg={setShowZoomImg}
    />

    <RequiredLoginAlertPopup
      showRequiredLoginAlertPopup={showRequiredLoginModal}
      onClose={setShowRequiredLoginModal}
    />

    <BlueprintImageFlowMarketModal
      marketFlow={marketFlow}
      showMarketFlow={showMarketFlow}
      setShowMarketFlow={setShowMarketFlow}
    />


    {
      productToShowGradingCertificate &&
      <GradingCertificate
        originalGradingCertificate={productToShowGradingCertificate ? productToShowGradingCertificate.current_grading : ''}
        originalLabel={productToShowGradingCertificate ? productToShowGradingCertificate.current_label : ''}
        originalBlueprintImage={blueprintImage2ShowLargeImage ? blueprintImage2ShowLargeImage : ''}
        showCertificate={showCertificate}
        setShowCertificate={setShowCertificate} />

    }
  </div>
};

export default OffersForSingleBlueprintImage;
